




















































































// project
import { Dictionary } from "@/utils/types";

type RowState = {
	dirty:boolean,
	valid:boolean
};

// vendor
import { defineComponent, PropType, computed, ref, set } from "@vue/composition-api";
// local
import { FormItem, LinearScale, DataChannel } from "../../ts/types";
import ErrorOverlay from "./error-overlay.vue";
import ErrorBox from "./error-box.vue";

export default defineComponent({

	emits:[ "input" ],
	props:{
		value:{
			type:Array as PropType<number[]>
		},
		config:{
			type:Object as PropType<FormItem<LinearScale>>,
			required:true
		}
	},
	components:{
		ErrorOverlay,
		ErrorBox
	},
	setup(props, context){

		const state = ref<Dictionary<RowState>>({});
		const pristine = ref(true);

		const val = computed({
			get:() => props.value,
			set:v => context.emit("input", v)
		});

		const rows = computed(() => props.config.settings.rows);
		const columns = computed(() => props.config.settings.columns);
		
		const hasLabels = computed(() => {

			const l = props.config.settings.rows
			.map(v => v.length)
			.reduce((a, b) => a + b, 0);
			return l > 0;
		});

		const fullState = computed(() => {
			let valid = true;
			let s = {
				dirty:false,
				valid:true
			};
			Object.keys(state.value).forEach(k => {
				s.valid = s.valid && state.value[k].valid
				s.dirty = s.dirty || state.value[k].dirty;
			});
			return s;
		});

		const isValid = () => {
			pristine.value = false;
			Object.keys(state.value).forEach(k => {
				state.value[k].dirty = false;
			});
			return fullState.value.valid;
		};

		const getChannels = (prefix:string):DataChannel<number>[] => {
			const v = val.value;
			if(!v){ return []; }
			return props.config.settings.rows.map((row, rIndex) => {
				return {
					key: `${prefix}/${rIndex}`,
					data: v[rIndex]
				};
			});
		};

		const isPicked = (row:number, col:number) => {
			if(!val.value){ return false; }
			return val.value[row] === col;
		}

		const pickColumn = (row:number, col:number) => {
			if(!val.value){ return; }
			set(state.value, `${row}`, {
				dirty:true,
				valid:true
			});
			set(val.value, row, col);
		}

		const init = () => {
			let arr = val.value
			if(!arr){
				arr = props.config.settings.rows.map(r => -1);
				val.value = arr;
			}
			let s:Dictionary<RowState> = {};
			arr.forEach((col, rowIndex) => {
				s[rowIndex] = {
					dirty:false,
					valid: col > -1
				};
			});
			
			state.value = s;
		};

		init();

		return {
			hasLabels,
			pristine,
			rows,
			columns,
			state,
			val,
			fullState,
			isPicked,
			pickColumn,
			isValid,
			getChannels
		};
	}
});
